import { DOMAINS, LANGUAGES } from 'state/intl/types';
import { Region } from 'utils/environment/types';
import { StorageKeys } from 'utils/local-storage';

export const LOCALE_SELECTED_QUERY_PARAM = 'locale-selected';

export const LOCALE_SEPARATOR = '-';

export const READABLE_LANGUAGES = {
  [LANGUAGES.en]: {
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
  },
  [LANGUAGES.fr]: {
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
  },
};

/* @TODO: let's just use formatMessage here instead of redefining for every language */
export const READABLE_REGIONS = {
  [LANGUAGES.en]: {
    [Region.CA]: 'Canada',
    [Region.US]: 'USA',
  },
  [LANGUAGES.fr]: {
    [Region.CA]: 'Canada',
    [Region.US]: 'États Unis',
  },
};

export const REGION_DOMAIN_VALUES = {
  US: DOMAINS.com,
  CA: DOMAINS.ca,
};

export const regionSpecificLocalStorageKeys = [
  StorageKeys.STORE,
  StorageKeys.AUTH_REDIRECT,
  StorageKeys.ORDER,
  StorageKeys.SERVICE_MODE,
];

export const supportedLanguagesByRegion = {
  us: {
    locales: ['en'],
    defaultLanguage: 'en',
  },
  ca: {
    locales: ['en', 'fr'],
    defaultLanguage: 'en',
  },
};
